import { graphql } from "../__generated__/gql";

export const GET_BANNER = graphql(`
  query GetBanner {
    banner {
      bannerId
      text
      startTime
      endTime
      ctaText
      ctaLink
    }
  }
`);

export default GET_BANNER;
